import { VITE_BASE_URL } from '@/config';
import { controlTypeFromMinutes } from './timeControl';

// Public cards need presentation data, not the tournament's mutation and pairing methods.
export function formatPublicTournament(entry) {
  const data = entry?.attributes || entry;
  if (!entry?.documentId || !data?.name || !data?.system) return null;
  const clubs = data.chess_clubs?.data || data.chess_clubs || [];
  const club = clubs[0]?.attributes || clubs[0] || {};
  const settings = (data.systemSettings?.data || data.systemSettings || [])[0] || {};
  const regular = data.system === 'mixed' ? settings.roundRobin || settings.swiss : settings;
  const controlSettings = data.system === 'mixed' ? regular || settings.elimination || {} : settings;
  const background = typeof club.background?.url === 'string' ? club.background.url.trim() : '';
  const base = String(VITE_BASE_URL || '').trim().replace(/\/$/, '');
  const backgroundUrl = !background ? null : !base || /^https?:\/\//i.test(background)
    ? background : `${base}${background.startsWith('/') ? '' : '/'}${background}`;
  return {
    id: entry.documentId,
    name: data.name,
    slug: data.slug,
    date: data.date,
    time: data.time,
    place: data.place || null,
    system: data.system,
    status: data.tournamentStatus,
    rated: Boolean(data.rated),
    chessVariant: data.chessVariant,
    competitionFormat: data.competitionFormat ?? 'individual',
    participantLimit: data.participantLimit ?? null,
    playersCount: Number(data.players?.count || 0),
    publicClubName: club.name || '',
    publicClubSlug: club.slug || '',
    publicClubCity: club.city || '',
    publicClubCountry: club.country || '',
    publicClubBackgroundUrl: backgroundUrl,
    publicClubBackground: club.background || null,
    controlSettings,
    // Match Tournament.getControlType(): it derives the control from the regular stage.
    controlType: data.system === 'elimination'
      ? controlTypeFromMinutes(null)
      : regular?.controlType || controlTypeFromMinutes(regular?.timeMinutes ?? null),
  };
}
